import tw from 'twin.macro'

const MenuTitle = tw.div``

export default MenuTitle
